import React from 'react'
import I18nCRUD from '../components/I18nCRUD'
import {I18nType} from '../../../utils/types'
import {i18n}  from '../../../i18n'
import {PageHeader} from 'antd'

const FormOfAddressPage = () => {
    return (
        <div>
            <PageHeader className='site-page-header-responsive' title={i18n.t('planner.formOfAddress.title')}
                        onBack={() => window.history.back()}>
                <I18nCRUD
                    type={I18nType.FORM_OF_ADDRESS}
                    newTitle={i18n.t('planner.formOfAddress.new')}
                    failUpdate={i18n.t('planner.formOfAddress.failUpdate')}
                    failGet={i18n.t('planner.formOfAddress.failGet')}
                    deleteTitle={i18n.t('planner.formOfAddress.delete')}
                />
            </PageHeader>
        </div>
    )
}

export default FormOfAddressPage
